import { configureStore } from '@reduxjs/toolkit';
import storeAuth from './authSlice';
import listNumbering from './listNumberingSlice';
import ui from './uiSlice';
import socket from './socketSlice';
import job from './jobSlice';
import error from './errorSlice';
import notifications from './notificationSlice';
import freeRewrite from './freeRewriteSlice';
import autowrite from './autowriteSlice';
import psychology from './psychologySlice';
import paperWrite from './paperWriteSlice';
import rewriteSlots from "./rewriteSlotSlice";
import featureFlags from './featureFlagsSlice';
import banner from './bannerSlice';
import supportChat from './supportChatSlice';
import { supportChatCacheListener } from './supportChatCacheListener';
import { registerLogoutCleanup } from './logoutCleanup';
import { clearUIState } from './uiSlice';
import { jobReset, clearAllDocumentJobs } from './jobSlice';
import { resetFreeRewrite } from './freeRewriteSlice';
import { clearRewriteSlots } from './rewriteSlotSlice';
import { resetSupportChat } from './supportChatSlice';
import { clearAllSupportChatCaches } from '../utils/supportChatCache';

export const store = configureStore({
  reducer: {
    storeAuth,
    listNumbering,
    ui,
    socket,
    job,
    error,
    notifications,
    freeRewrite,
    autowrite,
    psychology,
    paperWrite,
    rewriteSlots,
    featureFlags,
    banner,
    supportChat,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(supportChatCacheListener.middleware),
});

// Сброс слайсов основной сборки при выходе (см. authSlice.logout)
registerLogoutCleanup((dispatch, userId) => {
  if (userId != null) {
    clearAllSupportChatCaches(userId);
  }
  dispatch(clearUIState());
  dispatch(jobReset({}));
  dispatch(clearAllDocumentJobs());
  dispatch(resetFreeRewrite());
  dispatch(clearRewriteSlots());
  dispatch(resetSupportChat());
});

// Export store to window for easy access in browser console (dev only)
if (typeof window !== 'undefined') {
  (window as any).__store__ = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
